import { render, staticRenderFns } from "./CompanySuppressions.vue?vue&type=template&id=8007acce&"
import script from "./CompanySuppressions.vue?vue&type=script&lang=js&"
export * from "./CompanySuppressions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports